var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1963_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5824 5.76748L9.00863 5.74521C8.75258 5.74521 8.54291 5.95117 8.54291 6.20722C8.54291 6.46328 8.74887 6.67294 9.00492 6.67294L13.4655 6.6915L5.40903 14.7479C5.2272 14.9298 5.2272 15.2229 5.40903 15.4048C5.59087 15.5866 5.88403 15.5866 6.06587 15.4048L14.1223 7.34833L14.1408 11.8089C14.1408 12.0649 14.3505 12.2709 14.6066 12.2709C14.8626 12.2709 15.0686 12.0612 15.0686 11.8052L15.0463 6.23134C15.0445 5.97714 14.8366 5.76933 14.5824 5.76748Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1963_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.435,
    height: 13.435,
    fill: "white",
    transform: "translate(0 10) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/right-arrow-white.9f8db40acdb391e495e9b9bfcc0a145d.svg";
export { ForwardRef as ReactComponent };